const skills = [
  { name: "Python & SQL", desc: "Core languages for scripting, data processing, and querying" },
  { name: "AI/ML Concepts", desc: "AI, Machine Learning, Deep Learning, NLP, Neural Networks" },
  { name: "Libraries & Frameworks", desc: "TensorFlow, PyTorch, Keras, Pandas, Scikit-learn, OpenCV, CNNs" },
  { name: "Transformer Models", desc: "Hugging Face Transformers, LangChain" },
  { name: "Cloud & CI/CD", desc: "Azure (Model Deployment), Git, GitHub Actions" },
  { name: "API & Tools", desc: "Postman, Swagger UI, Streamlit, FastAPI, VS Code, Jupyter Notebook" },
];

export default function Skills() {
  return (
    <section id="skills" className="bg-gray-950 py-16 px-6 text-white">
      <h3 className="text-3xl text-red-500 font-bold text-center mb-10">Skill Set</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {skills.map((s, i) => (
          <div key={i} className="bg-gray-800 p-5 rounded shadow hover:shadow-lg transition">
            <h4 className="text-xl font-semibold mb-2">{s.name}</h4>
            <p className="text-sm text-gray-300">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
